import { checkIsWLByUrl } from 'commonUtils/queryUtils';

const URL_PARAMS_PREFIX = 'urlparams - ';

/**
 * Дописывает query-параметры из URL к eventLabel для передачи в GA/Яндекс.Метрику.
 * @param originalEventLabel - исходный label события
 * @param currentWindow - объект window
 * @returns eventLabel с добавленными url-параметрами или исходный label
 */
export const formatEventLabelWithQuery = (originalEventLabel?: string, currentWindow = window): string | undefined => {
  const currentSearch = currentWindow?.location?.search;
  const isWl = checkIsWLByUrl(currentWindow?.location?.href);

  if (!currentSearch || !isWl) {
    return originalEventLabel;
  }

  const urlParams = `${URL_PARAMS_PREFIX}${currentSearch}`;

  if (!originalEventLabel?.trim()) {
    return urlParams;
  }

  return `${originalEventLabel}|${urlParams}`;
};
